<template lang="pug">
.container-fluid
  .d-sm-flex.align-items-center.justify-content-between.mb-4
    h1.h3.mb-0.text-gray-800 Dashboard
    .d-none.d-sm-inline-block()    
      router-link(to="/dashboard/plans") Returns Remaining: {{getReturnsAvailable}}
  .row
    .col-lg-6.mb-4()
      .card.shadow.mb-4
        .card-header.py-3
          h6.m-0.font-weight-bold.text-primary Return History (1 week)
        .card-body(v-if="returnHistoryLoading == false")
          transition(name="fade")
            apexchart( type="line" :options="options" :series="series")    
        .card-body(v-if="returnHistoryLoading == true")          
          Spinner
    .col-lg-6.mb-4(style="display:grid;")
      .card.shadow.mb-4.rma-pending-wrap
        .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
          h6.m-0.font-weight-bold.text-primary Pending RMAs         
          .dropdown.no-arrow
            span 
              router-link(to="/dashboard/orders") view more            
        .card-body.rma-pending-wrap
          transition(name="fade")
            .col-12(v-if="rmasLoading == false")
              table.rma-pending
                thead
                  tr
                    th RMA No.
                    th Order No.
                    th Customer Email
                    th Type
                tbody(v-if="rmaPending.length > 0")
                  tr(v-for="rma in rmaPending")
                    td.dashboardRMA {{rma._id.toUpperCase().match(/.{1,6}/g).join('-')}}
                    td {{rma.orderName}}
                    td {{rma.email}}
                    td {{rma.type}}
                p(v-else) No Pending RMAs   
          .col-12(v-if="rmasLoading == true")            
            Spinner
  .row 
    .col-lg-12.mb-4
      .card.shadow.mb-4
        .card-header.py-3.d-flex.flex-row.align-items-center.justify-content-between
          h6.m-0.font-weight-bold.text-primary Recent Returns
          .dropdown.no-arrow
            span
              router-link(to="/dashboard/returns") view more
        .card-body.rma-pending-wrap(v-if="approvedReturnsLoading == false")
          transition(name="fade")
            table.approved-returns(v-if="approvedReturns.length > 0")
              thead
                tr
                  th Date
                  th Age
                  th Status
                  th Tracking No.
                  th Carrier
                  th Platform                  
              tbody
                tr(v-for="theReturn in approvedReturns")
                  td {{theReturn.created_at | moment("MM/DD/YYYY") }}
                  td {{ today - theReturn.created_at | duration("humanize")}}
                  td {{theReturn.status}}
                  td {{theReturn.trackingNumber}}
                  td {{theReturn.carrier}}
                  td {{theReturn.channel}}
            p(v-else) No Recent Returns
        .card-body(v-if="approvedReturnsLoading == true")
          Spinner
    //- .col-lg-6.mb-4
      .card.shadow.mb-4
        .card-header.py-3
          h6.m-0.font-weight-bold.text-primary Development Approach
        .card-body
          p
            | SB Admin 2 makes extensive use of Bootstrap 4 utility classes in order to reduce CSS bloat and poor page performance. Custom CSS classes are used to create custom components and custom utility classes.
          p.mb-0
            | Before working with this theme, you should become familiar with the Bootstrap framework, especially the utility classes.

</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from 'moment';
import Spinner from 'vue-simple-spinner';

import VueApexCharts from 'vue-apexcharts';


export default {
  name: 'DashboardHome',
  components: {
    apexchart: VueApexCharts,
    Spinner,

  },
  data(){
    return{
      today: new Date(),
      rmasLoading: true,
      returnHistoryLoading:true,
      approvedReturnsLoading:true,
      rmaPending:[],
      approvedReturns:[],
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: [moment().subtract(6, 'days').format('MM-DD'), moment().subtract(5, 'days').format('MM-DD'), moment().subtract(4, 'days').format('MM-DD'), moment().subtract(3, 'days').format('MM-DD'), moment().subtract(2, 'days').format('MM-DD'), moment().subtract(1, 'days').format('MM-DD'), moment().format('MM-DD')]
        },

      },
      series: [{
        name: 'Returns',
        data: [ 0, 0, 0, 0, 0, 0, 0]
      }]
    }
  },
  computed:{
    ...mapState(['user']),
    ...mapGetters(['getReturnsAvailable']),

  },
  methods:{
    async init(){
      this.rmasLoading = true;
      this.returnHistoryLoading = true;
      this.approvedReturnsLoading = true
      
      let rmas = await this.axios.get(`/rp/server/dashboard/rma/pending`);      
      this.rmaPending = rmas.data.pending_rmas.rmas;
      let returns = await this.axios.get(`/rp/server/returns/?limit=5 &offset=0`);
      for( let i = 0; i < returns.data.length; i++){
        this.approvedReturns.push(returns.data[i])
      }
      let returnHistory = await this.axios.get(`/rp/server/dashboard/return/history`)
      this.series[0].data = [ ...returnHistory.data.returns_history.history];
      this.rmasLoading = false;
      this.returnHistoryLoading = false;
      this.approvedReturnsLoading = false;
      


    },
  },
  metaInfo: {
    title: 'Dashboard Home',
  },
  created(){
    this.init();
  }
}
</script>
<style lang="scss" scoped>
.approved-returns{
  width:100%;
  overflow:auto;
  td{
    border-top:lightgrey solid 1px;
  }
}
.rma-pending-wrap{
  overflow:auto;
}
.dashboardRMA{
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rma-pending{
  width:100%;
  overflow:auto;
}
</style>
